import { PlusFill } from "../../../../../assets";
import { Icon } from "../../../../icon";
import "./toolbarbutton.css";
import { OperationToolbarButtonProps } from "./toolbarbutton.props";

const OperationToolbarButton: React.FC<OperationToolbarButtonProps> = ({
  show,
  icon,
  text,
  onClick,
  className,
  disabled = false,
}) => {
  return (
    <>
      {show && (
        <button
          className={`operation-toolbarbutton-button ${
            disabled ? "disabled" : ""
          } ${className}`}
          disabled={disabled}
          onClick={onClick}
        >
          <Icon
            icon={icon ?? PlusFill}
            alt="Icon plus"
            className={`operation-toolbarbutton-icon ${
              !text?.length ? "without-mr" : ""
            }`}
          />
          <p>{text}</p>
        </button>
      )}
    </>
  );
};

export default OperationToolbarButton;
